/*eslint react-hooks/exhaustive-deps: "off"*/
import React, {useEffect} from 'react';
import MapBase from "./MapBase";
import useMapProps from "./useMapProps";
import {MapPropsProvider} from "./MapPropsContext";
import WidgetContainer from "./widgets/WidgetContainer";
import WidgetGeocoding from "./widgets/WidgetGeocoding";
import {WELL_KNOWN_POSITION} from "../../Constants";
import RMateChartTable5G from "./r_mate_chart/RMateChartTable5G";
import WidgetToolbar from "./widgets/WidgetToolbar";
import WidgetLegend from "./widgets/WidgetLegend";


/**
 * 이동통신 5G 무선국
 * 분포도와 차트만 사용하는 페이지(19-11-26 new)
 */


const INITIAL_VIEW_STATE = {
  ...WELL_KNOWN_POSITION.fiveG,
  zoom: 8,
};


const Map5g = () => {
   const mapProps = useMapProps({
    INITIAL_VIEW_STATE
  });

  const {
    updateMapLayerNames,
    fiveG_layer,
    setFiveG_layer
  } = mapProps;

  useEffect(() => {
      setFiveG_layer('5G');
  }, []);

  useEffect(() => {
    updateMapLayerNames('5G', true);
  }, [updateMapLayerNames]);


  return (
    <MapPropsProvider value={mapProps}>
      <MapBase isIgnoreCenterChangeEvent={true} isHideControlOnClustering={true}>
        <WidgetContainer>
          <div>
            <WidgetGeocoding zoom={16}/>
            {/*<Widget5gDensity/>*/}
          </div>
        </WidgetContainer>
        <RMateChartTable5G
          cusList={fiveG_layer}
        />
        <WidgetLegend />
      </MapBase>
      <WidgetToolbar />
    </MapPropsProvider>
  );
};

export default Map5g;
